import {AbstractAPIPlatformProvider} from './abstract';
import {DocumentType as DocumentTypeModel} from '../model';
import {PROVIDER} from '../../../resources/bcmApi';
import {DocumentTypeSerializer} from '../serializer';

export class DocumentType extends AbstractAPIPlatformProvider {
  name = PROVIDER.DOCUMENT_TYPES;
  model = new DocumentTypeModel();
  serializer = new DocumentTypeSerializer();
}
